import * as React from 'react';
import { connect } from 'react-redux';

import MentionCardModalAssetInstagram from 'components/mention-card/mention-card-modal-asset/channels/instagram/MentionCardModalAssetInstagram';

import { fetchInstagramProfile } from 'modules/influencers/reducers/instagramInfluencers';

import type { InfluencerInstagram, MentionCardModalItem } from 'types';
import type { ConsentReducerConsentsMap } from 'redux-store/types/ConsentReducer.type';

type OwnProps = {
  selectedItem: MentionCardModalItem,
  currentPosition: number
};

type StateProps = {
  mapByUsername: {
    [x: string]: InfluencerInstagram | undefined | null
  },
  userChannelConsents: ConsentReducerConsentsMap
};

type DispatchProps = {
  dispatchFetchInstagramInfluencer: (username: string | undefined) => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

class DiscoveryContentModalAsset extends React.PureComponent<Props> {
  componentDidMount(): void {
    const { dispatchFetchInstagramInfluencer, selectedItem: { username } } = this.props;

    dispatchFetchInstagramInfluencer(username);
  }

  componentDidUpdate(prevProps: Props): void {
    const { dispatchFetchInstagramInfluencer, selectedItem: { username } } = this.props;
    const { selectedItem: { username: prevUsername } } = prevProps;

    if (username !== prevUsername) {
      dispatchFetchInstagramInfluencer(username);
    }
  }

  render() {
    const { selectedItem, currentPosition, mapByUsername, userChannelConsents } = this.props;
    const instagramProfile = selectedItem.username ? mapByUsername[selectedItem.username] : null;
    let item: MentionCardModalItem = selectedItem;

    if (instagramProfile) {
      // enrich with additional data
      item = {
        ...selectedItem,
        profileId: instagramProfile.id,
        profileName: instagramProfile.name,
        profileImageUrl: instagramProfile.profileImage,
        profileStatus: instagramProfile.profileStatus
      };
    }

    return (
      <MentionCardModalAssetInstagram
        userChannelConsents={userChannelConsents}
        selectedItem={item}
        currentPosition={currentPosition}
      />
    );
  }
}

const mapStateToProps = ({ instagramInfluencers, consentReducer }): StateProps => ({
  mapByUsername: instagramInfluencers.mapByUsername,
  userChannelConsents: consentReducer.consents
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchInstagramInfluencer: (username: string | undefined) => dispatch(fetchInstagramProfile(username))
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscoveryContentModalAsset);
